import { type InputHTMLAttributes, type ReactNode, type Ref } from 'react';
import FormInput from './FormInput';

interface Props extends Omit<InputHTMLAttributes<HTMLInputElement>, 'id' | 'type' | 'min' | 'max'> {
  id: string;
  ref?: Ref<HTMLInputElement>;
  min: number;
  max: number;
  suffix?: ReactNode;
  hasError?: boolean;
}

export default function FormNumberInput({ min, max, ...props }: Props) {
  return <FormInput type="number" min={min} max={max} {...props} />;
}
